import { render, staticRenderFns } from "./EmailQueueProcessor.vue?vue&type=template&id=004271e6"
import script from "./EmailQueueProcessor.vue?vue&type=script&lang=js"
export * from "./EmailQueueProcessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports